import { useState, useEffect } from "react";
import { createPayoutUrl, editPayOutUrl } from "../../api/endpoints";
import { useSelector, useDispatch } from "react-redux";
import { setUser } from "../../slice/webStoreUserSlice";
import { useNavigate } from "react-router-dom";
import { refreshUserToken } from "../../tools/refreshToken";

let tk = /* "RkB33GgoSCB1ts3yYiktSyc8oQzero4iG5MgYbym" */ "NUBAN-BZNWFBUV2006";
const unWantedInputs = ["+", "-", "e", "E", "."];

const BankTransfer = ({ openModal }) => {
  const [bankCode, setBankCode] = useState("");
  const [bankName, setBankName] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [isBankAndAccountNumberValid, setIsBankAndAccountNumberValid] = useState(false);
  const [isBankTransferFormValid, setIsBankTransferFormValid] = useState(false);
  const [accountName, setAccountName] = useState("");
  const [isValidating, setIsValidating] = useState(false);

  const { user } = useSelector((state) => state.webStoreUser);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (bankCode && accountNumber && accountNumber.length === 10) {
      setIsBankAndAccountNumberValid(true);
    } else {
      setIsBankAndAccountNumberValid(false);
      setIsBankTransferFormValid(false);
    }
  }, [bankCode, accountNumber]);

  const validateAccountNumber = async () => {
    setIsValidating(true);
    let endpoint = `https://app.nuban.com.ng/api/${tk} ?bank_code=${bankCode}&acc_no=${accountNumber}`;
    try {
      console.log(endpoint);
      let response = await fetch(endpoint, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + tk,
        },
      });

      let data = await response.json();
      console.log(data);
      if (data.error) {
        alert("Invalid account number");
        setIsBankTransferFormValid(false);
        setIsValidating(false);
      } else {
        if (data[0].account_name) {
          console.log(data);
          setAccountName(data[0].account_name);
          setBankName(data[0].bank_name);
          setIsBankTransferFormValid(true);
          setIsValidating(false);
        } else {
          console.log(data);
          alert("Invalid account number");
          setIsBankTransferFormValid(false);
          setIsValidating(false);
        }
      }
    } catch (error) {
      console.log(error);
      setIsValidating(false);
    }
  };

  const confirmBankPayout = async () => {
    console.log("confirmBankPayout");
    let endpoint = user.isPayOutMethodSet ? editPayOutUrl : createPayoutUrl;
    let fetchMethod = user.isPayOutMethodSet ? "PUT" : "POST";
    let payLoad = {
      payoutMethod: "Bank transfer" /* PayPal or HubCoin */,
      payoutBankCode: bankCode,
      payoutBankName: bankName,
      payoutAccountName: accountName,
      payoutAccountNumber: accountNumber,
    };
    try {
      let response = await fetch(endpoint, {
        method: fetchMethod,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("accessToken"),
        },
        body: JSON.stringify(payLoad),
      });
      if (response.ok) {
        let updatedUser = await response.json();
        dispatch(setUser(updatedUser));
        openModal(false);
      } else if (response.status === 400) {
        /* send refresh token */
        refreshUserToken(endpoint, confirmBankPayout, navigate);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div className='banktransferWrapper'>
        <div className='employeeTile22'>
          <div id='inputreset46' className='inputCustdet  '>
            <select value={bankCode} onChange={(e) => setBankCode(e.target.value)}>
              <option value='' disabled selected hidden>
                Select bank
              </option>
              {NIGERIAN_BANKS.map((bank, i) => (
                <option key={i} value={bank.code}>
                  {bank.name}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className='employeeTile22'>
          <div id='inputreset46' className='inputCustdet flexingValidate '>
            <input
              style={{ fontSize: "1rem" }}
              onKeyDown={(event) => unWantedInputs.includes(event.key) && event.preventDefault()}
              value={accountNumber}
              onChange={(e) => setAccountNumber(e.target.value)}
              maxLength={10}
              type={"number"}
              required={true}
            />

            <p className='placeholderInputcusd'>Account number </p>
            {isBankAndAccountNumberValid && isValidating === false ? (
              <div onClick={validateAccountNumber} className='isBankCodeValid3'>
                Validate
              </div>
            ) : (
              <div>Validate</div>
            )}
          </div>
        </div>
        <span className='choosenNamePayo'>Account name</span> <span>{accountName}</span>
        <div className='Btn-div37643'>
          <p>
            By proceeding you confirm to our <span style={{ color: "#5B79FF", cursor: "pointer" }}>privacy</span> and{" "}
            <span style={{ color: "#5B79FF", cursor: "pointer" }}>data policy</span>
          </p>

          <div className='confirmMethod2392'>
            {" "}
            {isBankTransferFormValid ? (
              <button onClick={confirmBankPayout} className='btnConfirmSele23'>
                Comfirm selection
              </button>
            ) : (
              <button style={{ backgroundColor: "#c2c2c2", cursor: "not-allowed" }} className='btnConfirmSele23' disabled>
                Comfirm selection
              </button>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default BankTransfer;

export const NIGERIAN_BANKS = [
  { code: "120001", name: "9mobile 9Payment Service Bank" },
  { code: "801", name: "Abbey Mortgage Bank" },
  { code: "51204", name: "Above Only MFB" },
  { code: "51312", name: "Abulesoro MFB" },
  { code: "044", name: "Access Bank" },
  { code: "063", name: "Access Bank (Diamond)" },
  { code: "602", name: "Accion Microfinance Bank" },
  { code: "50036", name: "Ahmadu Bello University Microfinance Bank" },
  { code: "120004", name: "Airtel Smartcash PSB" },
  { code: "035A", name: "ALAT by WEMA" },
  { code: "50926", name: "Amju Unique MFB" },
  { code: "51341", name: "AMPERSAND MICROFINANCE BANK" },
  { code: "50083", name: "Aramoko MFB" },
  { code: "401", name: "ASO Savings and Loans" },
  { code: "MFB50094", name: "Astrapolaris MFB LTD" },
  { code: "51229", name: "Bainescredit MFB" },
  { code: "50117", name: "Banc Corp Microfinance Bank" },
  { code: "50931", name: "Bowen Microfinance Bank" },
  { code: "565", name: "Carbon" },
  { code: "865", name: "CASHCONNECT MFB" },
  { code: "50823", name: "CEMCS Microfinance Bank" },
  { code: "50171", name: "Chanelle Microfinance Bank Limited" },
  { code: "023", name: "Citibank Nigeria" },
  { code: "50910", name: "Consumer Microfinance Bank" },
  { code: "50204", name: "Corestep MFB" },
  { code: "060001", name: "Coronation Merchant Bank" },
  { code: "51297", name: "Crescent MFB" },
  { code: "50162", name: "Dot Microfinance Bank" },
  { code: "050", name: "Ecobank Nigeria" },
  { code: "50263", name: "Ekimogun MFB" },
  { code: "098", name: "Ekondo Microfinance Bank" },
  { code: "50126", name: "Eyowo" },
  { code: "51318", name: "Fairmoney Microfinance Bank" },
  { code: "070", name: "Fidelity Bank" },
  { code: "51314", name: "Firmus MFB" },
  { code: "011", name: "First Bank of Nigeria" },
  { code: "214", name: "First City Monument Bank" },
  { code: "107", name: "FirstTrust Mortgage Bank Nigeria" },
  { code: "50315", name: "FLOURISH MFB" },
  { code: "501", name: "FSDH Merchant Bank Limited" },
  { code: "812", name: "Gateway Mortgage Bank LTD" },
  { code: "00103", name: "Globus Bank" },
  { code: "100022", name: "GoMoney" },
  { code: "50739", name: "Goodnews Microfinance Bank" },
  { code: "562", name: "Greenwich Merchant Bank" },
  { code: "058", name: "Guaranty Trust Bank" },
  { code: "51251", name: "Hackman Microfinance Bank" },
  { code: "50383", name: "Hasal Microfinance Bank" },
  { code: "030", name: "Heritage Bank" },
  { code: "120002", name: "HopePSB" },
  { code: "51244", name: "Ibile Microfinance Bank" },
  { code: "50439", name: "Ikoyi Osun MFB" },
  { code: "50442", name: "Ilaro Poly Microfinance Bank" },
  { code: "50457", name: "Infinity MFB" },
  { code: "301", name: "Jaiz Bank" },
  { code: "50502", name: "Kadpoly MFB" },
  { code: "082", name: "Keystone Bank" },
  { code: "50200", name: "Kredi Money MFB LTD" },
  { code: "50211", name: "Kuda Bank" },
  { code: "90052", name: "Lagos Building Investment Company Plc." },
  { code: "50549", name: "Links MFB" },
  { code: "031", name: "Living Trust Mortgage Bank" },
  { code: "303", name: "Lotus Bank" },
  { code: "50563", name: "Mayfair MFB" },
  { code: "50304", name: "Mint MFB" },
  { code: "50515", name: "Moniepoint MFB" },
  { code: "120003", name: "MTN Momo PSB" },
  { code: "100002", name: "Paga" },
  { code: "999991", name: "PalmPay" },
  { code: "104", name: "Parallex Bank" },
  { code: "311", name: "Parkway - ReadyCash" },
  { code: "999992", name: " OPay (Paycom)" },
  { code: "50743", name: "Peace Microfinance Bank" },
  { code: "51146", name: "Personal Trust MFB" },
  { code: "50746", name: "Petra Mircofinance Bank Plc" },
  { code: "076", name: "Polaris Bank" },
  { code: "50864", name: "Polyunwana MFB" },
  { code: "105", name: "PremiumTrust Bank" },
  { code: "101", name: "Providus Bank" },
  { code: "51293", name: "QuickFund MFB" },
  { code: "502", name: "Rand Merchant Bank" },
  { code: "90067", name: "Refuge Mortgage Bank" },
  { code: "50767", name: "ROCKSHIELD MICROFINANCE BANK" },
  { code: "125", name: "Rubies MFB" },
  { code: "51113", name: "Safe Haven MFB" },
  { code: "951113", name: "Safe Haven Microfinance Bank Limited" },
  { code: "50582", name: "Shield MFB" },
  { code: "50800", name: "Solid Rock MFB" },
  { code: "51310", name: "Sparkle Microfinance Bank" },
  { code: "221", name: "Stanbic IBTC Bank" },
  { code: "068", name: "Standard Chartered Bank" },
  { code: "51253", name: "Stellas MFB" },
  { code: "232", name: "Sterling Bank" },
  { code: "100", name: "Suntrust Bank" },
  { code: "50968", name: "Supreme MFB" },
  { code: "302", name: "TAJ Bank" },
  { code: "090560", name: "Tanadi Microfinance Bank" },
  { code: "51269", name: "Tangerine Money" },
  { code: "51211", name: "TCF MFB" },
  { code: "102", name: "Titan Bank" },
  { code: "100039", name: "Titan Paystack" },
  { code: "50840", name: "U&C Microfinance Bank Ltd (U AND C MFB)" },
  { code: "MFB51322", name: "Uhuru MFB" },
  { code: "50870", name: "Unaab Microfinance Bank Limited" },
  { code: "50871", name: "Unical MFB" },
  { code: "51316", name: "Unilag Microfinance Bank" },
  { code: "032", name: "Union Bank of Nigeria" },
  { code: "033", name: "United Bank For Africa" },
  { code: "215", name: "Unity Bank" },
  { code: "566", name: "VFD Microfinance Bank Limited" },
  { code: "035", name: "Wema Bank" },
  { code: "057", name: "Zenith Bank" },
];
